export const enum ExportRowsEnum {
  Selected = 1,
  AllFiltered = 2,
  AllWithFooters = 3,
}

export const enum ExportResultEnum {
  Success = 1,
  GridUnavailable = 2,
  EmptySelection = 3,
}



// WEBPACK FOOTER //
// ./src/app/core/enums/data-export.enum.ts